import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const SLOTS = ["12:30", "13:30", "19:00", "20:00", "21:00"];

export default function PartnerCalendar() {
  const [list, setList] = useState([]);
  const [anchor, setAnchor] = useState(new Date());

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/partner/inbox");
        setList(data);
      } catch (e) { /* ignore */ }
    })();
  }, []);

  const week = useMemo(() => {
    const start = new Date(anchor);
    start.setDate(start.getDate() - start.getDay());
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return d;
    });
  }, [anchor]);

  const byDateSlot = useMemo(() => {
    const m = new Map();
    for (const b of list) {
      const key = `${b.date}|${(b.time || "").slice(0, 5)}`;
      m.set(key, b);
    }
    return m;
  }, [list]);

  const colorFor = (status) => {
    const map = {
      submitted: "bg-amber-soft/40",
      restaurant_accepted: "bg-amber/30",
      confirmed: "bg-ink text-cream",
      deposit_paid: "bg-ink text-cream",
      rejected: "bg-rose-100",
      cancelled: "bg-tablo-border",
      completed: "bg-green-100",
    };
    return map[status] || "bg-cream";
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <header className="flex items-center justify-between">
        <div>
          <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Calendar</p>
          <h1 className="font-serif text-3xl">This week at a glance</h1>
        </div>
        <div className="flex gap-2">
          <button onClick={() => setAnchor(new Date(anchor.getTime() - 7 * 86400000))} className="tablo-btn-outline px-3 py-1.5 text-sm" data-testid="cal-prev">‹ Prev</button>
          <button onClick={() => setAnchor(new Date())} className="tablo-btn-outline px-3 py-1.5 text-sm" data-testid="cal-today">Today</button>
          <button onClick={() => setAnchor(new Date(anchor.getTime() + 7 * 86400000))} className="tablo-btn-outline px-3 py-1.5 text-sm" data-testid="cal-next">Next ›</button>
        </div>
      </header>

      <div className="tablo-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-cream">
              <th className="p-3 text-left text-xs uppercase tracking-wider text-light-ink">Slot</th>
              {week.map((d) => (
                <th key={d.toISOString()} className="p-3 text-left text-xs uppercase tracking-wider text-light-ink">
                  {d.toLocaleDateString("en-IN", { weekday: "short" })}<br/>
                  <span className="text-ink font-medium">{d.getDate()}/{d.getMonth() + 1}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {SLOTS.map((s) => (
              <tr key={s} className="border-t border-tablo-border">
                <td className="p-3 font-medium text-light-ink">{s}</td>
                {week.map((d) => {
                  const iso = d.toISOString().slice(0, 10);
                  const b = byDateSlot.get(`${iso}|${s}`);
                  return (
                    <td key={iso} className="p-2">
                      {b ? (
                        <div className={`rounded-lg p-2 text-xs ${colorFor(b.status)}`} data-testid={`cal-cell-${iso}-${s}`}>
                          <p className="font-medium truncate">{b.organizer?.name || b.organizer?.phone}</p>
                          <p className="opacity-80">{b.pax} guests</p>
                        </div>
                      ) : (
                        <div className="h-12 rounded-lg border border-dashed border-tablo-border/70"/>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
